import type { AccessGroup } from '@/api/auth';

/**
 * Who §6.10 is for, and the one predicate this screen gates on.
 *
 * §5's table gives *Settings* to **Admin** alone, and every route the screen touches agrees — the
 * staff writes (`STAFF_WRITE_ACCESS`), the accent and the logo (`BRANDING_WRITE_ACCESS`) are all
 * `Admin`-only rows in `backend/tests/test_permission_matrix.py`. **The exception is the one read**:
 * `GET /api/v1/users/` admits a Recruiter too (`STAFF_READ_ACCESS`), because assignment needs it.
 *
 * ⚠️ **So this screen's gate is the *write* group, not the read group**, and that asymmetry is the
 * reason it is written down rather than derived from `mayReadStaffDirectory`: a screen whose every
 * control is a refusal for a Recruiter is not a screen they should be shown with the buttons hidden —
 * §5's answer is that they do not have the address at all, and `RequireGroup` gives them the same
 * Not-found an unknown address gets.
 *
 * ⚠️ **It decides what is rendered and what is requested, never what may be written.** The server
 * refuses on its own; the client gate is what keeps this screen from firing four requests that are
 * refusals by design, and what keeps a demotion **without** a re-login (`useSession` has a
 * `staleTime`) from leaving a cached directory readable to somebody who has just lost the right.
 */
export const maySeeSettings = (groups: AccessGroup[]): boolean => groups.includes('Admin');
